export const text = {
  title: '#BF9663',
  suTitle: '',
  paragraph: '#D97016',
  paragraph2: '#9e4d06',
  btnText: '#1b1b1b',
};

export const buttons = {
  btn1: '#BF9663',
  btn2: '#D97016',
};

export const backgrounds = {
  bgPage: '#FFFFFF',
  bgModal: '#000000',
};
